import styled from 'styled-components';

export const IncentiveEvaluationMessagesContainer = styled.div`
  font-size: 0.75rem;
  color: ${Styles.color.red};
  display: flex;
  margin: 0.5rem 0 0;
  flex-direction: column;

  ul {
    padding: 0 0 0 1rem;
  }
`;

export const IconWrapper = styled.div`
  min-width: 1.5rem;
`;

export const SingleMessage = styled.div`
  align-items: center;
  display: flex;

  svg {
    margin-right: 0.5rem;
  }
`;
